import { getClient } from '@/features/graphql/client'
import { GraphqlChannel } from '@/features/graphql/constants'
import { getGraphqlUriFromLicenceUrl } from '@/features/graphql/utils'
import { useLicence } from '@/features/licence/hooks/useLicence'
import { usePosMode } from '@/features/pos/contexts/PosMode'
import { ApolloProvider } from '@apollo/client'
import { FC, ReactNode, useMemo } from 'react'

interface ApolloWrapperProps {
    children: ReactNode
    channel?: GraphqlChannel
}

const ApolloWrapper: FC<ApolloWrapperProps> = ({ children, channel }) => {
    const licence = useLicence()

    const mode = usePosMode()

    const resolvedChannel = channel ?? mode
    const client = useMemo(
        () =>
            getClient(getGraphqlUriFromLicenceUrl(licence.url), licence.language, resolvedChannel),
        [licence, resolvedChannel]
    )

    return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default ApolloWrapper
